import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function StoreCustomers() {
  const { sid } = useParams();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get(`/stores/${sid}/customers`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [sid]);

  return (
    <div className="p-8 lg:p-10">
      <div className="mb-6">
        <p className="eyebrow mb-2">Store · Guests</p>
        <h1 className="font-display font-bold text-3xl tracking-tight" data-testid="store-customers-title">Customers</h1>
        <p className="text-sm text-neutral-500 mt-1">Everyone who has ordered from this location.</p>
      </div>
      <div className="bg-white rounded-2xl border border-neutral-200/70 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-left text-xs uppercase tracking-wider text-neutral-500">
            <tr>
              <th className="p-4">Name</th>
              <th className="p-4">Email</th>
              <th className="p-4">Phone</th>
              <th className="p-4">Orders</th>
              <th className="p-4">Total Spent</th>
              <th className="p-4">Last Order</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-100">
            {rows.length === 0 && (
              <tr><td colSpan={6} className="p-10 text-center text-neutral-500" data-testid="store-customers-empty">No customers yet.</td></tr>
            )}
            {rows.map((c) => (
              <tr key={c.email} data-testid={`store-customer-${c.email}`}>
                <td className="p-4 font-medium">{c.name || "—"}</td>
                <td className="p-4 text-neutral-600">{c.email}</td>
                <td className="p-4 text-neutral-600">{c.phone || "—"}</td>
                <td className="p-4">{c.orders}</td>
                <td className="p-4 font-semibold">${c.spent.toFixed(2)}</td>
                <td className="p-4 text-neutral-500">{(c.last_order_at || "").slice(0, 16).replace("T", " ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
